import React, {ReactElement} from "react";

import Card, {CardProps} from "../../cards/card/Card";
import ModuleBody from "../module-body/ModuleBody";
import WidgetBreadcrumbs, {
  WidgetBreadcrumbsLink,
} from "../../widgets/widget-breadcrumbs/WidgetBreadcrumbs";
import WidgetShare from "../../widgets/widget-share/WidgetShare";
import CardLayout from "../card-layout/CardLayout";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./breadcrumbs-share-card-layout.module.scss";

interface BreadcrumbsShareCardLayoutProps {
  breadcrumbs?: Array<WidgetBreadcrumbsLink>;
  cards: Array<CardProps>;
  copy?: string;
  headline?: string;
  shareable?: boolean;
  cardImageClasses?: string;
  cardClasses?: string;
}

const BreadcrumbsShareCardLayout = (
  props: BreadcrumbsShareCardLayoutProps
): ReactElement => {
  const {
    breadcrumbs,
    cards,
    copy,
    headline,
    shareable,
    cardImageClasses,
    cardClasses,
  } = props;

  return (
    <section className={styles.breadcrumbsShareCardLayout}>
      <ModuleBody classes={styles.breadcrumbsShareCardLayout__body}>
        {headline && (
          <h2
            className={css("h2", styles.breadcrumbsShareCardLayout__headline)}
          >
            {headline}
          </h2>
        )}

        {copy && (
          <p className={css("p", styles.breadcrumbsShareCardLayout__copy)}>
            {copy}
          </p>
        )}

        {breadcrumbs && <WidgetBreadcrumbs links={breadcrumbs} />}

        {shareable && <WidgetShare />}

        <CardLayout
          column="3"
          items={(cards || []).map((card, i) => {
            const key = generateKeyId(
              `share-widget-card-layout-${card.headline}-${i}`
            );

            return (
              <Card
                key={key}
                {...card}
                gatsbyImageWrapperClasses={css(
                  styles.breadcrumbsShareCardLayout__cardImage,
                  cardImageClasses!
                )}
                classes={css(
                  styles.breadcrumbsShareCardLayout__card,
                  cardClasses!
                )}
              />
            );
          })}
          classes={styles.breadcrumbsShareCardLayout__cards}
        />
      </ModuleBody>
    </section>
  );
};

export default BreadcrumbsShareCardLayout;
